// Durations (_DUR- block) — persisted in localStorage.
// Même pattern que categories.js. Valeurs numériques en secondes (chaîne).
// Défauts alignés sur le template d'ExportTab.js (DUR-[15|30|60]).
const LS_KEY = 'timbo_durations_v1';

const DEFAULT_DURATIONS = ['15', '30', '60'];

export function getDurations() {
  try {
    const saved = JSON.parse(localStorage.getItem(LS_KEY));
    return saved && saved.length ? saved : [...DEFAULT_DURATIONS];
  } catch { return [...DEFAULT_DURATIONS]; }
}

export function saveDurations(list) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch {}
}

export function sanitizeDuration(v) {
  return (v || '').toString().replace(/[^0-9]/g, '');
}

export default DEFAULT_DURATIONS;
